// Importaciones de React, el componente Card y las imágenes necesarias.
import React from 'react';
import Card from './Card'; // Importa el componente reutilizable para mostrar cada tarjeta.
import img from '../img/tarjeta.jpg';
import imgg from '../img/tarjetaa.jpg';
import imggg from '../img/calidad.jpg';
import imgggg from '../img/tarjetaaaa.jpg';
import imggggg from '../img/tarjetaaaaa.jpg';
import imgggggg from '../img/socios.jpg';

/**
 * Array de objetos que contiene los datos para cada una de las tarjetas de la propuesta de valor.
 * Centralizar los datos aquí facilita la modificación del contenido sin tocar la lógica del componente.
 */
const cardsData = [
  {
    id: 1,
    title: "Enfoque Holístico",
    content: "Ciberseguridad e Inteligencia artificial, pilares en la oferta a nuestros clientes, estamos concentrado en incrementar la productividad a la vez que reducimos los riesgos de seguridad.",
    imgSrc: img,
  },
  {
    id: 2,
    title: "Asesoría y soporte continuo",
    content: "Nuestros productos y servicios incluyen soporte y asesorías para optimizar la inversión de nuestros clientes.",
    imgSrc: imgg,
  },
  {
    id: 3,
    title: "Calidad en la entrega",
    content: "Usamos metodologías probadas para la gestión de incidentes, requerimientos y proyectos, que permiten medir cada etapa en el proceso de despliegue y corregir las desviaciones.",
    imgSrc: imggg,
  },
  {
    id: 4,
    title: "Aplicación de mejores prácticas",
    content: "Las recomendaciones se basan en un análisis de la situación de ciberseguridad, pero aplicar mejores prácticas es clave para reducir riesgos.",
    imgSrc: imgggg,
  },
  {
    id: 5,
    title: "Relación Ganar - Ganar",
    content: "Creamos relaciones a largo plazo, basadas en la confianza y transparencia, donde el retorno de su inversión en ciberseguridad es totalmente medible en la reducción de riesgos.",
    imgSrc: imggggg,
  },
  {
    id: 6,
    title: "Socios estratégicos",
    content: "Estamos a tu lado, apoyamos tu estrategia de negocio, nos adaptamos a tus necesidades y crecemos juntos.",
    imgSrc: imgggggg,
  },
];

/**
 * Componente Propuesta de Valor.
 * Muestra una sección con un título y una cuadrícula de tarjetas (Cards)
 * que describen los puntos clave de la propuesta de valor de la empresa.
 */
export const Propuesta = () => {
  return (
    // Contenedor principal de la sección con un color de fondo específico.
    <div className="bg-[#061C5B] p-10">
      
      {/* Título de la sección. */}
      <h2 className="text-4xl font-bold text-center text-white mb-10">PROPUESTA DE VALOR</h2> 
      
      {/* Línea decorativa. */}
      <div className='linea-dos'></div> 
      
      {/* Cuadrícula (grid) que organiza las tarjetas. Es adaptable a diferentes tamaños de pantalla. */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-center">
        
        {/* Itera sobre el array `cardsData` y renderiza un componente `Card` por cada objeto. */}
        {cardsData.map(card => (
          <Card 
            key={card.id} // `key` es crucial para que React identifique cada elemento de forma única.
            title={card.title} 
            content={card.content} 
            imgSrc={card.imgSrc} 
          /> 
        ))}
      </div>
    </div>
  );
};

// Exporta el componente para ser utilizado en otras partes de la aplicación.
export default Propuesta;
